import { useEffect, useState } from 'react';
import { api } from '@/services/api';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

export const UserManagement = () => {
    const [users, setUsers] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchUsers = async () => {
        setLoading(true);
        const res = await api.getAdminUsers();
        if (res.success) setUsers(res.data || []);
        setLoading(false);
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handlePunish = async (userId: string, action: string) => {
        if (!confirm(`本当にこのユーザーに対して「${action}」を実行しますか？`)) return;
        const res = await api.adminPunishUser(userId, action, 'VIOLATION');
        if (res.success) {
            alert('実行しました');
            fetchUsers();
        } else {
            alert(res.error || '失敗しました');
        }
    };

    if (loading) return <div className="p-8 text-center text-primary animate-pulse">読み込み中...</div>;

    return (
        <div className="rounded-md border-2 border-ink/15 bg-surface">
            <Table>
                <TableHeader>
                    <TableRow className="border-ink/15 hover:bg-transparent">
                        <TableHead className="text-ink-2">ユーザー</TableHead>
                        <TableHead className="text-ink-2">ステータス</TableHead>
                        <TableHead className="text-ink-2">権限フラグ</TableHead>
                        <TableHead className="text-right text-ink-2">操作</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {users.map((u) => (
                        <TableRow key={u.id} className="border-ink/15 hover:bg-cream text-ink-2">
                            <TableCell className="flex items-center gap-3">
                                <span className="font-mono text-[10px] text-ink-3">{u.id.slice(0, 8)}</span>
                                <span className="font-bold">{u.display_name}</span>
                            </TableCell>
                            <TableCell>
                                <Badge variant={u.status === 'active' ? 'outline' : 'destructive'} className={u.status === 'active' ? 'text-green-400 border-green-400' : ''}>
                                    {u.status}
                                </Badge>
                            </TableCell>
                            <TableCell className="font-mono text-xs text-ink-2">
                                {u.flags}
                            </TableCell>
                            <TableCell className="text-right space-x-2">
                                {u.status === 'active' ? (
                                    <Button size="sm" variant="destructive" onClick={() => handlePunish(u.id, 'ban')}>BAN</Button>
                                ) : (
                                    <Button size="sm" variant="outline" onClick={() => handlePunish(u.id, 'pardon')}>解除</Button>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                    {users.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={4} className="text-center py-8 text-ink-3">ユーザーが見つかりません</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </div>
    );
};
